import { useClient, useDictionary, useItems } from "@adamlip/okeoke.client";
import { Button, Select, SelectItem } from "@nextui-org/react";
import { UserContext } from "contexts/UserContext";
import { useContext } from "react";
import { toast } from "react-hot-toast";
import Icon from "assets/icons";
import CustomInput from "components/CustomInput";
import { AppParamsContext } from "contexts/AppParamsContext";

export default function Diet() {
  const { getValue } = useDictionary();
  const { getName } = useClient();
  const { assembledItems } = useItems();
  const { appParams } = useContext(AppParamsContext);
  const {
    saveUserData,
    handleChangeUserAttributes,
    handleChangeUserData,
    userData,
    isVipBrand,
  } = useContext(UserContext);

  const allergens = [
    "gluten",
    "peanuts",
    "treeNuts",
    "celery",
    "mustard",
    "eggs",
    "milk",
    "sesame",
    "fish",
    "crustaceans",
    "molluscs",
    "soya",
    "sulphites",
    "lupin",
  ];

  const handleResponse = (res) => {
    if (res.uuid || res.success) {
      toast.success(getValue("app_v2_toast_profileSuccess"));
    } else {
      toast.error(getValue("app_v2_toast_profileError"));
    }
  };

  const handleUserDataSave = () => {
    saveUserData(handleResponse);
  };

  const onClickButton = (allergen) => {
    //console.log(allergen);
    handleChangeUserAttributes({
      target: {
        name: "allergens",
        value: {
          ...userData?.attributes?.allergens,
          [allergen]:
            userData?.attributes?.allergens?.[allergen] === 0 ||
            userData?.attributes?.allergens?.[allergen] == null
              ? 1
              : 0,
        },
      },
    });
  };

  const onClickFoodButton = (allergen) => {
    //console.log(allergen);
    handleChangeUserAttributes({
      target: {
        name: "foodTags",
        value: {
          ...userData?.attributes?.foodTags,
          [allergen]:
            userData?.attributes?.foodTags?.[allergen] === 0 ||
            userData?.attributes?.foodTags?.[allergen] == null
              ? 1
              : 0,
        },
      },
    });
  };

  const onOtherBlur = (value) => {
    handleChangeUserAttributes(value);
  };

  if (!isVipBrand)
    return (
      <div className="flex flex-col gap-2 items-center justify-center h-full w-full  relative overflow-y-scroll pb-[50%]">
        <div className="">{getValue("vip.not.available")}</div>
        <Button color="primary" onPress={() => window.location.reload()}>
          {getValue("vip.reload")}
        </Button>
      </div>
    );

  return (
    <div
      className={`flex flex-col gap-4 grow overflow-hidden ${
        appParams?.styles?.fonts?.capitalize ? "font-extrabold uppercase" : ""
      }`}
    >
      <div className="font-bold text-xl">
        {getValue("app_v2_profile_diet_title")}
      </div>
      <div className="overflow-auto grow flex flex-col gap-4">
        {Object.values(assembledItems || {}).filter((item) =>
          item?.tags?.includes("favoriteDish")
        ).length > 0 && (
          <>
            <div className="">{getValue("profile.fav.food")}</div>
            <Select
              aria-label="12"
              name="favoriteFood"
              classNames={{
                label: `${
                  appParams?.styles?.fonts?.capitalize
                    ? "font-bold uppercase"
                    : ""
                } group-data-[filled=true]:text-foreground-500`,
                value: appParams?.styles?.fonts?.capitalize
                  ? "font-bold uppercase"
                  : "",
              }}
              selectedKeys={
                userData?.favoriteFood
                  ? [userData?.favoriteFood.toString()]
                  : ["0"]
              }
              label={getValue("app_v2_profile_favoriteFood")}
              onChange={handleChangeUserData}
            >
              <SelectItem
                aria-label="0"
                key={"0"}
                value={"0"}
                textValue={getValue("app_v2_profile_favoriteFood")}
                className={
                  appParams?.styles?.fonts?.capitalize
                    ? "font-bold uppercase"
                    : ""
                }
              >
                {getValue("app_v2_profile_favoriteFood")}
              </SelectItem>
              {Object.values(assembledItems || {})
                .filter((item) => item?.tags?.includes("favoriteDish"))
                .map((item) => (
                  <SelectItem
                    aria-label="121"
                    key={item.uuid}
                    value={item.uuid}
                    textValue={getName(item.name)}
                    className={
                      appParams?.styles?.fonts?.capitalize
                        ? "font-bold uppercase"
                        : ""
                    }
                  >
                    {getName(item.name)}
                  </SelectItem>
                ))}
            </Select>
          </>
        )}
        <div className="">{getValue("profile.food.tags")}</div>
        <div className="flex gap-2 flex-wrap justify-center">
          <Button
            key={"vegetarian"}
            size="md"
            className={`h-auto w-auto py-2`}
            isIconOnly
            onPress={() => onClickFoodButton("vegetarian")}
          >
            <div
              key={"vegetarian"}
              className={`flex flex-col items-center gap-1 p-3`}
            >
              <div className="h-12 w-12">
                <Icon
                  name={"vegetarian"}
                  className={
                    userData?.attributes?.foodTags?.["vegetarian"]
                      ? "fill-white"
                      : "fill-foreground/70"
                  }
                  secondClassName={
                    userData?.attributes?.foodTags?.["vegetarian"]
                      ? "fill-primary/80"
                      : "fill-background"
                  }
                />
              </div>
              <div className="text-tiny uppercase">
                {getValue(`food.tag.vegetarian`)}
              </div>
            </div>
          </Button>
          <Button
            key={"dairyFree"}
            size="lg"
            className={`h-auto w-auto py-2 min-w-[90px]`}
            isIconOnly
            onPress={() => onClickFoodButton("dairyFree")}
          >
            <div
              key={"dairyFree"}
              className={`flex flex-col items-center gap-1 p-3`}
            >
              <div className="h-12 w-12">
                <Icon
                  name={"dairyFree"}
                  className={
                    userData?.attributes?.foodTags?.["dairyFree"]
                      ? "fill-white stroke-white"
                      : "fill-foreground/70 stroke-foreground/70"
                  }
                  secondClassName={
                    userData?.attributes?.foodTags?.["dairyFree"]
                      ? "fill-primary/80"
                      : "fill-background"
                  }
                />
              </div>
              <div className="text-tiny uppercase">
                {getValue(`food.tag.dairyFree`)}
              </div>
            </div>
          </Button>
          <Button
            key={"vegan"}
            size="lg"
            className={`h-auto w-auto py-2 min-w-[90px]`}
            isIconOnly
            onPress={() => onClickFoodButton("vegan")}
          >
            <div
              key={"vegan"}
              className={`flex flex-col items-center gap-1 p-3`}
            >
              <div className="h-12 w-12">
                <Icon
                  name={"vegan"}
                  className={
                    userData?.attributes?.foodTags?.["vegan"]
                      ? "fill-white"
                      : "fill-foreground/70"
                  }
                  secondClassName={
                    userData?.attributes?.foodTags?.["vegan"]
                      ? "fill-primary/80"
                      : "fill-background"
                  }
                />
              </div>
              <div className="text-tiny uppercase">
                {getValue(`food.tag.vegan`)}
              </div>
            </div>
          </Button>
          <Button
            key={"glutenFree"}
            size="lg"
            className={`h-auto w-auto py-2 min-w-[90px]`}
            isIconOnly
            onPress={() => onClickFoodButton("glutenFree")}
          >
            <div
              key={"glutenFree"}
              className={`flex flex-col items-center gap-1 p-3 ${userData?.attributes?.foodTags?.["glutenFree"]}`}
            >
              <div className="h-12 w-12">
                <Icon
                  name={"glutenFree"}
                  className={
                    userData?.attributes?.foodTags?.["glutenFree"]
                      ? "fill-primary/80 stroke-white"
                      : "fill-background"
                  }
                  secondClassName={
                    userData?.attributes?.foodTags?.["glutenFree"]
                      ? "fill-background stroke-background"
                      : "fill-foreground stroke-foreground"
                  }
                />
              </div>
              <div className="text-tiny uppercase">
                {getValue(`food.tag.glutenFree`)}
              </div>
            </div>
          </Button>
        </div>
        <div className="">{getValue("profile.allergens")}</div>
        <div className="flex gap-2 flex-wrap justify-center">
          {allergens.map((allergen) => (
            <Button
              key={allergen}
              size="lg"
              className={`h-auto w-auto py-2 min-w-[80px]`}
              isIconOnly
              onPress={() => onClickButton(allergen)}
            >
              <div
                key={allergen}
                className={`flex flex-col items-center gap-1 p-3`}
              >
                <div className="h-12 w-12">
                  <Icon
                    name={allergen}
                    className={
                      userData?.attributes?.allergens?.[allergen]
                        ? "fill-white"
                        : "fill-foreground/70"
                    }
                    secondClassName={
                      userData?.attributes?.allergens?.[allergen]
                        ? "fill-primary/80"
                        : "fill-background"
                    }
                  />
                </div>
                <div className="text-tiny uppercase">
                  {getValue(`allergens.${allergen}`)}
                </div>
              </div>
            </Button>
          ))}
        </div>
        <div>{getValue("allergens.other")}</div>
        <CustomInput
          onBlur={onOtherBlur}
          placeholder={getValue("allergens.other.specify")}
          name="otherAllergens"
          defaultValue={userData?.attributes?.otherAllergens}
        />
      </div>
      <Button
        fullWidth
        color="primary"
        className={`${
          appParams?.styles?.fonts?.capitalize ? "font-extrabold uppercase" : ""
        } rounded-[var(--general-button-border-radius)] shrink-0`}
        onClick={handleUserDataSave}
      >
        {getValue("app_v2_profile_save")}
      </Button>
    </div>
  );
}
